import { createReducer } from 'redux-starter-kit';
import {
  fetchCompoundBundles,
  fetchCompoundBundlesSuccess,
  fetchCompoundBundlesFailure,
  clearResults,
  cacheSettings,
  setSearchFor,
  searchFor
} from 'actions/home';
import { loginSuccess, registerSuccess, logout } from 'actions/auth';
import { orderBundleSuccess, orderTemplateSuccess } from 'actions/order';

const defaultSettings = {
  searchFor: ''
};
const defaultLists = {
  imageBundles: [],
  audioBundles: [],
  templates: []
};
export default createReducer(
  {
    ...defaultLists,
    ...defaultSettings,
    isLoading: false,
    prevState: null
  },
  {
    [clearResults]: state => ({
      ...state,
      ...defaultLists
    }),
    [cacheSettings]: state => {
      const { searchFor } = state;
      return {
        ...state,
        prevState: JSON.stringify({ searchFor })
      };
    },
    [fetchCompoundBundles]: state => ({
      ...state,
      isLoading: true
    }),
    [fetchCompoundBundlesSuccess]: (state, action) => ({
      ...state,
      imageBundles: [...state.imageBundles, ...action.payload.image_bundles],
      audioBundles: [...state.audioBundles, ...action.payload.audio_bundles],
      templates: [...state.templates, ...action.payload.templates],
      isLoading: false
    }),
    [fetchCompoundBundlesFailure]: state => ({
      ...state,
      isLoading: false
    }),
    [setSearchFor]: (state, action) => ({
      ...state,
      searchFor: action.payload
    }),
    [searchFor]: (state, action) => ({
      ...state,
      searchFor: action.payload
      // ...defaultLists
    }),

    // Auth
    [loginSuccess]: state => ({
      ...state,
      ...defaultLists,
      prevState: null
    }),
    [registerSuccess]: state => ({
      ...state,
      ...defaultLists,
      prevState: null
    }),
    [logout]: state => ({
      ...state,
      ...defaultLists,
      prevState: null
    }),
    // Order bundle & template
    [orderBundleSuccess]: state => ({
      ...state,
      ...defaultLists,
      prevState: null
    }),
    [orderTemplateSuccess]: state => ({
      ...state,
      ...defaultLists,
      prevState: null
    }),
  }
);
